import { BROADCAST_SET_MIXER_ATTENDEE } from 'actions/Types';

export default attendeeId => {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_MIXER_ATTENDEE,
      payload: attendeeId
    };

    dispatch(action);
  };
};
